//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/Builder.js";
let d=[[[0,"RuleMatchOptions",1,0]],[[[],"GetRulePath",{R_:{path:''}},0,0],[["path"],"SetRulePath",{},1,0],[["n_faces"],"GetFaces",{R_:{a_faces:"DisplayableObject[]"}},0,0],[["a_faces"],"SetFaces",{},1,0],[["name","super_name"],"AddNewFeatureType",{},2,0],[["name"],"RemoveFeatureType",{},1,0],[["name","new_name"],"RenameFeatureType",{},2,0],[["name","library_path","feature_type_name"],"AddNewRule",{},3,0],[["path"],"RemoveRule",{},1,0],[["path","new_name"],"RenameRule",{},2,0],[[],"Teach",{},0,0],[["n_features"],"Test",{R_:{a_features:"CAM.CAMFeature[]"}},0,0]],[]];
SPLM.CAM.FeatureTeaching = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.FeatureTeaching";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.FeatureTeaching.RuleMatchOptionType = Object.freeze({
    "PmiConds" : "PmiConds", "GeomAttrs" : "GeomAttrs", "GeomNames" : "GeomNames", "FaceColors" : "FaceColors"});

export default SPLM;